import { Table, Spin, message, Image, Form, Input, Space, DatePicker, Radio, Divider, Select, Tooltip, Button, InputNumber, Modal, Popconfirm } from 'antd';
import debounce from 'lodash/debounce';
import APIUtils from '../../api/APIUtils';
import WebLinks from '../../api/WebLinks';
import { useEffect, useState } from 'react';
import constants from '../../constants/constants';
import Cookies from 'js-cookie';
import { useContext } from 'react';
import moment from 'moment';
import { CommonContext, CurrencyContext } from '../../Context';
import { PlusOutlined,EyeOutlined} from '@ant-design/icons';
import dayjs from 'dayjs';
import { getCurrencyName, trackPageAccess } from '../../globalFunctions/GlobalFunctions';

const { Column } = Table;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { TextArea } = Input;

const BillingFinance = (props) => {
	//Variable Declaration
	const commonContext=useContext(CommonContext);
	const buyerId = commonContext.common.buyerId;
	const currencyContext=useContext(CurrencyContext);
	const [ordersData, setOrders] = useState([]);
	const [suppliers, setSuppliers] = useState([]);
	const [pageNumber, setPageNumber] = useState(1);
	const [sortDesc, setSortDesc] = useState(false);
	const [total, setTotal] = useState(0);
	const [loading, setloading] = useState(false);
	const [rangePickerValue, setRangePickerValue] = useState([]);
	const [suplierListLoader,setSuplierListLoader]= useState(false);
	const [allowedSupplierList, setAllowedSupplierList] = useState([]);
  const [productsOrderList, setProductOrderList] = useState([]);
	const [productsListLoader, setProductsListLoader] = useState(false);
  const [selectedSupplierIds,setSelectedsupplierIds]=useState([]);
  const [selectedProductIds,setSelectedProductIds]=useState([]);
	const [type, setType] = useState(1);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [contract,setContract]=useState("");
  const [billing,setBilling]=useState("");
  const [showBilling,setShowBilling]=useState("f");
	const [form] = Form.useForm();
  const [formCreate] = Form.useForm();
	const [isNoteModalOpen, setIsNoteModalOpen] = useState(false);
	const [formNote] = Form.useForm();

  // Table columns
  const columns = [
		{
			title: 'Id',
			dataIndex: 'id',
			key: 'id',
			sorter: (a, b) =>
				(a?.id ?? 0) - (b?.id ?? 0)
		},
		{
      title: 'Buyer',
      dataIndex: 'buyerName',
      key: 'buyerName',
    },
		{
			title: 'Contract',
			dataIndex: 'startOfContract',
			key: 'startOfContract',
			render: (startOfContract,item) => {
					 {return<span className='whitespace-nowrap'><p>{moment(startOfContract ).format('YYYY-MM-D')+" - "}</p><p>{ moment(item.endOfContract ).format('YYYY-MM-D') +" - "}</p><p>{ item.contractPeriod}</p></span>}
			},
		},
		// {
		// 	title: 'Contract Start',
		// 	dataIndex: 'startOfContract',
		// 	key: 'startOfContract',
		// 	render: (startOfContract) => {
		// 			 {return<span className='whitespace-nowrap'><p>{moment(startOfContract ).format('YYYY-MM-D') }</p></span>}
		// 	},
		// 	sorter: (a, b) => moment(a.startOfContract ).unix() - moment(b.startOfContract ).unix(),
		// },
		// {
		// 	title: 'Contract End',
		// 	dataIndex: 'endOfContract',
		// 	key: 'endOfContract',
		// 	render: (endOfContract) => {
		// 			{return<span className='whitespace-nowrap'><p>{moment(endOfContract ).format('YYYY-MM-D')}</p></span>}
		// 	},
		// 	sorter: (a, b) => moment(a.endOfContract ).unix() - moment(b.endOfContract ).unix(),
		// },
    // {
    //   title: 'Contract Period',
    //   dataIndex: 'contractPeriod',
    //   key: 'contractPeriod',
    //   sorter: (a, b) => a.contractPeriod.localeCompare(b.contractPeriod),
    // },
    // {
		// 	title: 'Created On',
		// 	dataIndex: 'createdOn',
		// 	key: 'createdOn',
		// 	render: (createdOn) => {
		// 			 {return<span className='whitespace-nowrap'><p>{moment(createdOn).format('YYYY-MM-D')}</p></span>}
		// 	},
		// 	sorter: (a, b) => moment(a.createdOn).unix() - moment(b.createdOn).unix(),
		// },
		{
			title: 'Billing Start',
			dataIndex: 'startOfBillingDate',
			key: 'startOfBillingDate',
			render: (startOfBillingDate) => {
        {return<span className='whitespace-nowrap'><p>{moment(startOfBillingDate).format('YYYY-MM-D')}</p></span>}
      },
      sorter: (a, b) => moment(a.startOfBillingDate).unix() - moment(b.startOfBillingDate).unix(),
    },
		{
			title: 'Billing End',
			dataIndex: 'endOfBillDate',
			key: 'endOfBillDate',
			render: (endOfBillDate) => {
					{return<span className='whitespace-nowrap'><p>{moment(endOfBillDate).format('YYYY-MM-D')}</p></span>}
			},
			sorter: (a, b) => moment(a.endOfBillDate).unix() - moment(b.endOfBillDate).unix(),
		},
		{
      title: 'Billing Period',
      dataIndex: 'billingPeriod',
      key: 'billingPeriod',
      sorter: (a, b) => a.billingPeriod.localeCompare(b.billingPeriod),
    },
    // {
		// 	title:"Suppliers",
		// 	dataIndex: 'suppliers',
		// 	key: 'suppliers',
		// 	width: '20%',
		// 	render: (text, record, index) =>
		// 	<>
		// 		{ record.logoURL && record.logoURL!==""? <Image src={record.logoURL} preview={false} width={100}/> : <span className='uppercase font-bold text-gray-400'>{record.supplierName} </span>}
		// 	</>
		// },
		{
			title: 'Product',
			dataIndex: 'productName',
			key: 'productName',
			sorter: (a, b) => a.productName - b.productName,
		},
    {
			title: 'Product Type',
      dataIndex: 'productType',
      key: 'productType',
      sorter: (a, b) => a.productType - b.productType,
    },
		{
			title: 'Invoice Details',
			key: 'invoiceDetails',
			render: (_, record) => {
				const details = record?.invoiceDetails;
				if (!details) return '';

				return record?.id ? `${record.id} - ${details}` : details;
			},
			sorter: (a, b) => a?.invoiceDetails?.localeCompare(b?.invoiceDetails),
		},
    {
      title: 'Invoice Currency',
      dataIndex: 'invoiceCurrency',
      key: 'invoiceCurrency',
      //sorter: (a, b) => a.invoiceCurrency - b.invoiceCurrency,
    },
    {
      title: 'Invoice Amount',
      dataIndex: 'invoiceAmount',
      key: 'invoiceAmount',
      sorter: (a, b) => a.invoiceAmount - b.invoiceAmount,
    },
		{
      title: 'Invoice ID',
      dataIndex: 'invoiceId',
      key: 'invoiceId',
      sorter: (a, b) => a.invoiceId - b.invoiceId,
      render: (invoiceId,item) => {
        {return invoiceId?<span className='whitespace-nowrap'><p>{invoiceId}</p></span>:<Space.Compact ><Input onChange={(e)=>{item.tempInvoicedId=e.target.value}} className="w-14"/><Button onClick={()=>UpdateInvoiceId(item)}><PlusOutlined /></Button></Space.Compact>}
    },
    },
    {
			title: 'Invoiced On',
			dataIndex: 'invoiceIdUpdatedOn',
			key: 'invoiceIdUpdatedOn',
			render: (invoiceIdUpdatedOn,item) => {
						return<> 
						{invoiceIdUpdatedOn?<span className='whitespace-nowrap'><p>{moment(invoiceIdUpdatedOn).format('YYYY-MM-D')+" "}</p></span>
						:""}
						 {item.invoiceId?
							<Popconfirm title="Sure you want to delete?" onConfirm={() => handleDelete(item.id)} placement="left">
							<Button type='link'>Delete</Button>
						</Popconfirm>:""}
						</>
	 		},
			sorter: (a, b) => moment(a.invoiceIdUpdatedOn).unix() - moment(b.invoiceIdUpdatedOn).unix(),
		},
    {
      title: 'Created By',
      dataIndex: 'createdBy',
      key: 'createdBy',
    },
		{
			title: 'Notes',
			key: 'notes',
			align: 'center',
			render: (_, record) => (record.invoiceNotes||record.notesToIssuer?<Tooltip title="View Note" >
					<EyeOutlined onClick={()=>setNoteDetails(record.invoiceNotes||"",record.notesToIssuer||"")}/>
			</Tooltip>:null)
	},
  ];
	//On page load
	useEffect(() => {
		const date1 = dayjs().startOf('month')
		const date2 = dayjs().endOf('month')
		form.setFieldsValue({
			rangePicker: [
				date1,
				date2,
			],
		});
		setRangePickerValue([
			date1,
			date2
		]);
		fetchData(date1.format('YYYY-MM-DD'), date2.format('YYYY-MM-DD'),type,null,null);
		getAllowedSuppliers();
    getAllOrderProducts();
	}, [props]);

	useEffect(() => {
		trackPageAccess(buyerId,window.location.href)
	}, []);
	//Functions
	//Function to fetch orders data
	const fetchData = async (date1, date2,type,supplierids,productids) => {
		setloading(true);
		let url=WebLinks.GetBilingFinance + buyerId +
		'&fromDate=' + date1 + '&toDate=' + date2 + '&filter=' + type;
		if(supplierids&&supplierids.length>0){
			url= url+"&supplierId="+supplierids
		}
		if(productids&&productids.length>0){
			url= url+"&productId="+productids
		}
		const orders = await APIUtils.apiCall("GET", url, null);
		if (orders.isCatch) {
			message.error(constants.ERROR_MESSAGE);
		} else {
			if (orders.resultObj?.statusCode === "2000") {
				setOrders(orders.resultObj.data)
				setTotal(orders.resultObj.data?.getCount | 0);
			} else {
				setOrders([]);
				setTotal(0);
				message.success(orders.resultObj?.message | constants.ERROR_MESSAGE)
			}
		}
		setloading(false);
	}

  //Delete record
  const handleDelete = async(id) => {
    const deleteResponse = await APIUtils.apiCall("PUT",WebLinks.DeleteBillingFinanceOrder+id);
    if(deleteResponse.isCatch || deleteResponse?.resultObj?.statusCode!=='2000'){
      message.error( deleteResponse?.resultObj?.message || constants.ERROR_MESSAGE);
    }else{
      message.success(deleteResponse?.resultObj?.message)
      fetchData(rangePickerValue[0].format('YYYY-MM-DD'), rangePickerValue[1].format('YYYY-MM-DD'), type,selectedSupplierIds,selectedProductIds);
    }
  };
	//Function to get Allowed suppliers list
	const getAllowedSuppliers =async()=>{
		setSuplierListLoader(true);
		const response = await APIUtils.apiCall('GET',WebLinks.GetALlAllowedSuppliersAllowedOrders);
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			setAllowedSupplierList(response?.resultObj?.data||[])
			setSuplierListLoader(false);
		}else{
			setAllowedSupplierList([]);
			setSuplierListLoader(false);
			message.error(response.resultObj.message);
		}
	}

  //Function to get order products
  const getAllOrderProducts= async()=>{
		setProductsListLoader(true);
    const response = await APIUtils.apiCall('GET',WebLinks.GetOrderProductList);
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			setProductsListLoader(false);
			setProductOrderList(response?.resultObj?.data||[])
		}else{
			setProductOrderList([]);
			setProductsListLoader(false);
			message.error(response.resultObj.message);
		}
  }
  
	const changeType = (radio) => {
		setType(radio.target.value)
		fetchData(rangePickerValue[0].format('YYYY-MM-DD'), rangePickerValue[1].format('YYYY-MM-DD'), radio.target.value,selectedSupplierIds,selectedProductIds);
	}

 	//Function on change of supplier selection
	const handleSupplierSelect=(selectedSuppliers)=>{
		if(selectedSuppliers.length>0){
			let tempSelectedSuppliers=selectedSuppliers.filter(value => value !== 'showall');
			let selectedSuppliersFinal=tempSelectedSuppliers.length>0?tempSelectedSuppliers:"";
			form.setFieldsValue({
				supplierList:selectedSuppliersFinal
			})
			setSelectedsupplierIds(selectedSuppliersFinal);
			fetchData(rangePickerValue[0].format('YYYY-MM-DD'), rangePickerValue[1].format('YYYY-MM-DD'), type,selectedSuppliersFinal,selectedProductIds);
		}else{
			form.setFieldsValue({
				supplierList:["showall"]
			})
			setSelectedsupplierIds([]);
			fetchData(rangePickerValue[0].format('YYYY-MM-DD'), rangePickerValue[1].format('YYYY-MM-DD'), type,null,selectedProductIds);
		}
	}
	//Function on change of product selection
	const handleProductSelect = (selectedProducts) => {
		if (selectedProducts.length > 0) {
			let tempSelectedProducts = selectedProducts.filter(value => value !== 'showall');
			let selectedProductsFinal = tempSelectedProducts.length > 0 ? tempSelectedProducts : "";
			form.setFieldsValue({
				productsList: selectedProductsFinal
			})
			setSelectedProductIds(selectedProductsFinal);
			fetchData(rangePickerValue[0].format('YYYY-MM-DD'), rangePickerValue[1].format('YYYY-MM-DD'), type, selectedSupplierIds, selectedProductsFinal);
		} else {
			form.setFieldsValue({
				productsList: ["showall"]
			})
			setSelectedProductIds([]);
			fetchData(rangePickerValue[0].format('YYYY-MM-DD'), rangePickerValue[1].format('YYYY-MM-DD'), type, selectedSupplierIds, null);
		}
	}

  //Update InvoiceId
  const UpdateInvoiceId=async(item)=>{
		setloading(true);
    if(item.tempInvoicedId){
		let UpdatedByBuyerId=Cookies.get(constants.COOKIE_LOGGED_BUYER_ID);
		const Response = await APIUtils.apiCall("PUT", WebLinks.UpdateBillingFinanceInvoiceDetails+ "invoiceId=" +  item.tempInvoicedId+"&id="+item.id +"&updatedByBuyerId="+UpdatedByBuyerId,null);
    if (Response.isCatch) {
      message.error(Response.resultObj.message);
			setloading(false);
    } else {
			setloading(false)
      message.success(Response.resultObj.message);
			fetchData(rangePickerValue[0].format('YYYY-MM-DD'), rangePickerValue[1].format('YYYY-MM-DD'), type,selectedSupplierIds,selectedProductIds);
    }
    }else{
			setloading(false);
      message.error("Please Enter Invoice Id.")
    }
  }
	const RangePickerChanged = debounce((_, dateStrings) => {
		const date1 = dayjs(dateStrings[0], constants.MonthFormat)
		const date2 = dayjs(dateStrings[1], constants.MonthFormat)
		setRangePickerValue([
			date1,
			date2
		]);
		fetchData(date1.format('YYYY-MM-DD'), date2.format('YYYY-MM-DD'),type,selectedSupplierIds,selectedProductIds);
	}, 500);

	const handleNoteCancel = () => {
		formNote.resetFields();
		setIsNoteModalOpen(false);
	};

	const setNoteDetails=(noteData,issuerNote)=>{
		setIsNoteModalOpen(true);
		formNote.setFieldsValue({
			note:noteData?noteData+""+issuerNote:issuerNote
	});
	}
	//Render
	return (
    <>
    <div className='uppercase font-bold text-xl'>Billing Finance</div>
			<Divider className='my-3'/>
		<div>
			<div className='flex flex-wrap gap-3 justify-between items-center mb-3'>
				<Space wrap>
					<Form form={form}>
						<Space wrap>
						<Form.Item name="rangePicker" className='mb-0'>
							<RangePicker picker="month"
								placeholder={["From", "To"]}
								onChange={RangePickerChanged}
								format={constants.MonthFormat} />
						</Form.Item>
						<Tooltip title="Suppliers">
							<Form.Item name="supplierList" className='mb-0'>
								<Select
									loading={suplierListLoader}
									className='!w-60'
									// value={selectedSupplier || []}
									placeholder={constants.supplierName}
									mode='multiple'
									allowClear
									defaultValue={"showall"}
									showSearch
								filterOption={(input, option) =>
										option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
										option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
								}
									onChange={(e) => handleSupplierSelect(e)}
									>
										<Option key='showall' value='showall'>Show all</Option>
											{allowedSupplierList?.map((supplier) => (
												<Option key={supplier.supplierId}
														value={supplier.supplierId}
												>
												{supplier.name}</Option>
									))}
								</Select>
							</Form.Item>
						</Tooltip>
						<Tooltip title="Products">
							<Form.Item name="productsList" className='mb-0'>
							<Select
								loading={productsListLoader}
								className='!w-60'
								placeholder={"Products"}
								mode='multiple'
								allowClear
								defaultValue={"showall"}
								showSearch
								filterOption={(input, option) =>
									option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
									option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
								}
									onChange={(e) => handleProductSelect(e)}
							>
								<Option key='showall' value='showall'>Show all</Option>
									{productsOrderList?.map((product) => (
									<Option key={product.id}
										value={product.id}
									>
										{product.productName}</Option>
								))}
							</Select>
							</Form.Item>
						</Tooltip>
						</Space>
					</Form>
				</Space>
				<Space wrap>
					<Radio.Group name="radiogroup" defaultValue={type} onChange={changeType}>
						<Radio value={1}>Billing Start</Radio>
						<Radio value={2}>Billing End</Radio>
            <Radio value={3}>Contract Start</Radio>
            <Radio value={4}>Contract End</Radio>
					</Radio.Group>
				</Space>
			</div>
			<div className='overflow-x-auto'>
			<Table
          loading={loading}
          size='small'
						onRow={(record) => ({
							className: record.billingPostPay ? "billing-post-pay-row" : "",
							style: record.billingPostPay
								? { backgroundColor: "#fef3c7" }
								: undefined,
						})}
          pagination={{
            //current: pagination.current,
            showSizeChanger: true,
            pageSizeOptions: ["200", "500", "1000", "2000"],
            defaultPageSize: 200,
						
            // onChange: (page, pageSize) => {
            //   setPagination({
            //     current: page,
            //     pageSize: pageSize
            //   });
            // }
          }}
          columns={columns}
          dataSource={ordersData}
        />
			</div>
		</div>
		<Modal 
      title={"Invoice Notes"} 
      open={isNoteModalOpen} 
      onCancel={handleNoteCancel}
      footer={null}
            >
      <Form
        name="basic"
        form={formNote}
      >
        <Form.Item
        label=""
        name="note"
        >
          <TextArea rows={4} />
        </Form.Item>
      </Form>
    </Modal>
   </>
	);
};

export default BillingFinance;